import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { interval, Subscription, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { InMemoryStorageService } from './in-memory-storage.service';

import { switchMap, retryWhen, delay, takeWhile, tap, catchError, finalize, scan } from 'rxjs/operators';
// import { AuthGuard } from '../auth.guard';
@Injectable({
    providedIn: 'root'
})
export class SessionService implements OnDestroy, OnInit {
    private heartbeatSubscription: Subscription | null = null;
    private readonly heartbeatUrl = `${environment.authApiUrl}heartbeat?username=`;
    private username: string = ''; // Store username for heartbeat

    constructor(
        private http: HttpClient,
        private router: Router,
        private inMemoryStorage: InMemoryStorageService // Assuming you have an InMemoryStorageService
        // private authGuard: AuthGuard
    ) {}

    /**
     * Angular lifecycle hook.
     * Starts the heartbeat when the service is initialized.
     */
    ngOnInit(): void {
        // Set the username here or fetch from a user service/auth service
        const userProfileStr = localStorage.getItem('userProfile');
        this.username = userProfileStr ? JSON.parse(userProfileStr).userName || '' : ''; // Replace with actual logic
        console.log('Initializing SessionService with username:', this.username);

        this.startHeartbeat(this.username);
    }

    /**
     * Starts the heartbeat interval.
     * Sends a POST request to the heartbeat endpoint every 25 seconds.
     * If a 401 error is received, navigates to the login page.
     * @param username The username to include in the heartbeat request.
     */
//     startHeartbeat(username: string): void {
//         console.log('Starting heartbeat...');
//         console.log(`Heartbeat URL: ${this.heartbeatUrl}`);
//         console.log('Username:', username);

//         // Unsubscribe from any existing heartbeat before starting a new one
//         this.stopHeartbeat();

//  const retryDurationMs = environment.HeartBeatinterval;  // = 90,000 ms
// const retryDelayMs = environment.HeartBeatinterval / 5; // = 18,000 ms
//         let startTime = Date.now();

//         this.heartbeatSubscription = interval(environment.HeartBeatinterval)
//             .pipe(
//                 switchMap(() => {
//                     console.log('Interval triggered');
//                     return this.http.post(this.heartbeatUrl + username, {}, { responseType: 'text' as 'json' });
//                 }),
//                 retryWhen((errors) =>
//                     errors.pipe(
//                         tap((err) => console.error('Heartbeat failed, retrying...', err)),
//                         delay(retryDelayMs),
//                         takeWhile(() => Date.now() - startTime < retryDurationMs),
//                         // 👇 restart heartbeat once retries are exhausted
//                         finalize(() => {
//                             console.warn('Retry window ended. Restarting heartbeat...');
//                             this.startHeartbeat(username);
//                         })
//                     )
//                 ),
//                 catchError((error) => {
//                     console.error('Heartbeat permanently failed:', error);
//                     localStorage.removeItem('accessToken');
//                     localStorage.removeItem('userProfile');
//                     console.log('Session expired. Redirecting to login...');
//                     this.router.navigate(['/login']);
//                     return throwError(() => error);
//                 })
//             )
//             .subscribe({
//                 next: (response) => {
//                     console.log('Heartbeat response:', response);
//                     startTime = Date.now(); // reset timer on success
//                 },
//                 error: (err) => {
//                     console.error('Subscription error:', err);
//                 }
//             });
//     }

startHeartbeat(username: string): void {
  console.log('Starting heartbeat...');
  console.log(`Heartbeat URL: ${this.heartbeatUrl}`);
  console.log('Username:', username);

  // Stop any existing heartbeat
  this.stopHeartbeat();

  const retryDelayMs = environment.HeartBeatinterval / 5; // 18s

  this.heartbeatSubscription = interval(environment.HeartBeatinterval)
    .pipe(
      switchMap(() => {
        console.log('Interval triggered');
        return this.http.post(this.heartbeatUrl + username, {}, { responseType: 'text' as 'json' });
      }),
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            console.error(`Heartbeat failed (attempt ${retryCount + 1})`, error);
            if (retryCount >= 2) { // After 3 tries total
              throw error; // Pass to catchError below
            }
            return retryCount + 1;
          }, 0),
          delay(retryDelayMs)
        )
      ),
      catchError((error) => {
        console.error('Heartbeat permanently failed:', error);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userProfile');
        console.log('Session expired. Redirecting to login...');
        this.router.navigate(['/login']);
        return throwError(() => error);
      })
    )
    .subscribe({
      next: (response) => console.log('Heartbeat response:', response),
      error: (err) => console.error('Subscription error:', err),
    });
}

    /**
     * Stops the heartbeat interval and unsubscribes from the observable.
     */
    stopHeartbeat(): void {
        console.log('Stopping heartbeat...');

        if (this.heartbeatSubscription) {
            this.heartbeatSubscription.unsubscribe();
            this.heartbeatSubscription = null;
        }
    }

    /**
     * Angular lifecycle hook.
     * Called when the service is destroyed.
     * Ensures the heartbeat is stopped to prevent memory leaks.
     */
    ngOnDestroy(): void {
        console.log('SessionService destroyed, stopping heartbeat...');
        this.stopHeartbeat();
    }
}
